{
  "completed": "Finalizat: ",
  "current": "Actual: ",
  "notCompleted": "Nefinalizat: ",
  "steplist": "Lista de pași"
}
